import useGetFlightsFromItinerary from '@/src/hooks/itinerary/useGetFlightsFromItinerary'
import { Flight } from '@/src/types/itinerary'
import FlightDetails from './flightDetails'

interface FlightDetailsWrapperProps {
    flights?: Flight[]
    isConfirmationPage?: boolean
    isPnrLoading?: boolean
}

const FlightDetailsWrapper = ({ flights: propFlights, isConfirmationPage = false, isPnrLoading = false }: FlightDetailsWrapperProps) => {
    const apiFlights = useGetFlightsFromItinerary({
        skip: isConfirmationPage
    })

    const flights = propFlights || apiFlights || []

    return <FlightDetails flights={flights} isConfirmationPage={isConfirmationPage} isPnrLoading={isPnrLoading} />
}

export default FlightDetailsWrapper
